import { toast } from "sonner";
import { departmentDisplayName } from "@/utils/alerts/departmentAlerts.js";

export const showAlertToast = (alert) => {
  toast.info(alert.title || "New hotel alert", {
    description: `${departmentDisplayName(alert.department)} · ${
      alert.roomNumber && alert.roomNumber !== "—" ? `Room ${alert.roomNumber}` : "Room not set"
    }`,
    action: {
      label: "Open",
      onClick: () => {
        window.location.assign(alert.route || "/hotel/calls");
      },
    },
  });
};
